import { defineMessages } from 'react-intl';

export const sharedFilterErrorMessages = defineMessages({
  genericError: {
    id: 'omicsExplorer.notification.genericQueryError',
    defaultMessage: 'There was an error with the request.',
  },
  serverError: {
    id: 'omicsExplorer.notification.serverQueryError',
    defaultMessage:
      'There was an error with the request, please contact an admin.',
  },
  timeoutError: {
    id: 'omicsExplorer.notification.timeoutQueryError',
    defaultMessage: 'The request timed out.',
  },
});
